const HtmlContent = ({ content }) => {
    return (
        <div style={{ lineHeight: "22.75px" }} dangerouslySetInnerHTML={{ __html: content }} />
    );
};

export default HtmlContent;